/**
 * 녹화 봇 감지 유틸리티
 *
 * DivisionScreen, SideSubVideoList, PresenterScreen에서 공통으로 사용하는
 * 녹화 서버 참여자 필터링 함수.
 */

/** 녹화 서버 봇의 statsId 목록 */
export const RECORDING_STATS_IDS = new Set(['wehagorecord', 'wehagorecord-dev']);

/** 참여자가 녹화 봇인지 확인 */
export const isRecordingBot = (p: { properties: Record<string, unknown> }): boolean => {
  const statsId = p.properties?.statsId;
  return typeof statsId === 'string' && RECORDING_STATS_IDS.has(statsId);
};
